module.exports = __webpack_public_path__ + "efe66b9e5b9c85d9f3befa1028c6586d.pdf";